module.exports = __webpack_public_path__ + "static/media/braden-collum.1c3edd4c.jpg";